import { UrlShortenerEndpointsService } from '../services/short-link';
import type { UpdateURLRequest, URLRequest } from '../services/short-link';

export type CreateURLPayload = URLRequest;
export type UpdateLinkPayload = UpdateURLRequest;

export const createShortLink = (payload: CreateURLPayload) => {
  return UrlShortenerEndpointsService.shortenUrlUrlShortenerApiV1ShortenPost(
    payload
  );
};

export const getShortLinkById = (shortId: string) => {
  return UrlShortenerEndpointsService.getOriginalUrlUrlShortenerApiV1ShortIdGet(
    shortId
  );
};
export const deleteShortLink = (shortId: string) => {
  return UrlShortenerEndpointsService.deleteUrlUrlShortenerApiV1ShortIdDelete(
    shortId
  );
};

export const updateShortLink = (
  shortId: string,
  payload: UpdateLinkPayload
) => {
  return UrlShortenerEndpointsService.updateUrlUrlShortenerApiV1ShortIdPut(
    shortId,
    payload
  );
};
